import React, { useEffect } from "react";
import "./InfoModal.css";
import { X, Info, CheckCircle, AlertTriangle, XCircle } from "lucide-react";

const icons = {
  info: Info,
  success: CheckCircle,
  warning: AlertTriangle,
  error: XCircle,
};

export default function InfoModal({
  isOpen,
  message = "",
  onClose,
  variant = "info",          // "info" | "success" | "warning" | "error"
  autoCloseMs = 0,           // e.g. 2500 to autoclose; 0 disables
}) {
  const Icon = icons[variant] || Info;

  useEffect(() => {
    if (!isOpen || !autoCloseMs) return;
    const t = setTimeout(() => onClose?.(), autoCloseMs);
    return () => clearTimeout(t);
  }, [isOpen, autoCloseMs, onClose]);

  if (!isOpen) return null;

  return (
    <div className="im-overlay" onClick={onClose}>
      <div
        className={`im-card im-${variant}`}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <button className="im-close" onClick={onClose} aria-label="Close">
          <X size={20} />
        </button>

        <div className="im-row">
          <div className="im-icon">
            <Icon size={28} />
          </div>
          <div className="im-text">{message}</div>
        </div>
      </div>
    </div>
  );
}
